import PropTypes from 'prop-types';
import { Box } from '@mui/material';

// Animated interlocking rings loader
const ConsentLoader = ({ size = 48, color = '#00AB55' }) => {
    const id = `consent-loader-${Math.random().toString(36).slice(2, 8)}`;

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size,
                height: size,
            }}
        >
            <style>{`
                @keyframes ${id}-ringA {
                    from, 4% { stroke-dasharray: 0 660; stroke-width: 20; stroke-dashoffset: -330; }
                    12% { stroke-dasharray: 60 600; stroke-width: 30; stroke-dashoffset: -335; }
                    32% { stroke-dasharray: 60 600; stroke-width: 30; stroke-dashoffset: -595; }
                    40%, 54% { stroke-dasharray: 0 660; stroke-width: 20; stroke-dashoffset: -660; }
                    62% { stroke-dasharray: 60 600; stroke-width: 30; stroke-dashoffset: -665; }
                    82% { stroke-dasharray: 60 600; stroke-width: 30; stroke-dashoffset: -925; }
                    90%, to { stroke-dasharray: 0 660; stroke-width: 20; stroke-dashoffset: -990; }
                }
                @keyframes ${id}-ringB {
                    from, 12% { stroke-dasharray: 0 220; stroke-width: 20; stroke-dashoffset: -110; }
                    20% { stroke-dasharray: 20 200; stroke-width: 30; stroke-dashoffset: -115; }
                    40% { stroke-dasharray: 20 200; stroke-width: 30; stroke-dashoffset: -195; }
                    48%, 62% { stroke-dasharray: 0 220; stroke-width: 20; stroke-dashoffset: -220; }
                    70% { stroke-dasharray: 20 200; stroke-width: 30; stroke-dashoffset: -225; }
                    90% { stroke-dasharray: 20 200; stroke-width: 30; stroke-dashoffset: -305; }
                    98%, to { stroke-dasharray: 0 220; stroke-width: 20; stroke-dashoffset: -330; }
                }
                @keyframes ${id}-ringC {
                    from { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: 0; }
                    8% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -5; }
                    28% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -175; }
                    36%, 58% { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: -220; }
                    66% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -225; }
                    86% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -395; }
                    94%, to { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: -440; }
                }
                @keyframes ${id}-ringD {
                    from, 8% { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: 0; }
                    16% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -5; }
                    36% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -175; }
                    44%, 50% { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: -220; }
                    58% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -225; }
                    78% { stroke-dasharray: 40 400; stroke-width: 30; stroke-dashoffset: -395; }
                    86%, to { stroke-dasharray: 0 440; stroke-width: 20; stroke-dashoffset: -440; }
                }
            `}</style>
            <svg width={size} height={size} viewBox="0 0 240 240">
                <circle
                    cx="120" cy="120" r="105" fill="none" stroke={color}
                    strokeWidth="20" strokeDasharray="0 660" strokeDashoffset="-330" strokeLinecap="round"
                    style={{ animation: `${id}-ringA 2s linear infinite`, opacity: 0.9 }}
                />
                <circle
                    cx="120" cy="120" r="35" fill="none" stroke={color}
                    strokeWidth="20" strokeDasharray="0 220" strokeDashoffset="-110" strokeLinecap="round"
                    style={{ animation: `${id}-ringB 2s linear infinite`, opacity: 0.7 }}
                />
                <circle
                    cx="85" cy="120" r="70" fill="none" stroke={color}
                    strokeWidth="20" strokeDasharray="0 440" strokeLinecap="round"
                    style={{ animation: `${id}-ringC 2s linear infinite`, opacity: 0.8 }}
                />
                <circle
                    cx="155" cy="120" r="70" fill="none" stroke={color}
                    strokeWidth="20" strokeDasharray="0 440" strokeLinecap="round"
                    style={{ animation: `${id}-ringD 2s linear infinite`, opacity: 0.6 }}
                />
            </svg>
        </Box>
    );
};

ConsentLoader.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
};

export default ConsentLoader;
